module.exports = __webpack_public_path__ + "static/media/laptop-white.09c8317b.svg";